import {minuteInMS, Observer, secondInMS} from "web-vcore";
import React from "react";
import {CheckBox, Column, Row, RowLR, Spinner, Text, TextInput, TimeSpanInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {GetLights_WithUserTag} from "../../../../Server/DB/lights.js";
import {ControlInput} from "../../../@Shared/ControlInput.js";
import {EffectPreviewButton} from "../../../@Shared/TagTargetEntryUI.js";
import {EngineConfigPanels_SharedProps, ExtendEngineConfigPanelSharedProps} from "../ConfigPanel_Local.js";
import {observer_mgl} from "mobx-graphlink";
import {SpinnerForPercent} from "../../../../Utils/ReactComponents/SpinnerForPercent.js";

const GetSharedProps = (props: EngineConfigPanels_SharedProps)=>ExtendEngineConfigPanelSharedProps(props, c=>c.journeyEntry, (c, v)=>c.journeyEntry = v);

const splitAt = 150;

export const JourneyEntry_ConfigUI = observer_mgl((props: {remote?: boolean} & EngineConfigPanels_SharedProps)=>{
	const {client, enabled} = props;
	const sharedProps = GetSharedProps(props);
	const {config, ChangeConfig} = sharedProps;

	return (
		<Column mt={15} style={{background: "hsla(0,0%,100%,.1)", borderRadius: 5, padding: 5}}>
			<Row style={{fontSize: 18}}>
				<CheckBox text="Journey -> Entry Mode" enabled={enabled} value={config.enabled} onChange={val=>ChangeConfig(c=>c.enabled = val)}/>
			</Row>

			{config.enabled &&
			<>
				<RowLR mt={5} splitAt={splitAt}>
					<Text mr={5}>Voice, tag:</Text>
					<TextInput enabled={enabled} style={{width: 80}} value={config.voiceSoundTag} onChange={val=>ChangeConfig(c=>c.voiceSoundTag = val)}/>
					<Text ml={5} mr={5}>Vol. mult.:</Text>
					<SpinnerForPercent enabled={enabled} min={0} max={999} value={config.volumeMultiplier} onChange={val=>ChangeConfig(c=>c.volumeMultiplier = val)}/>
				</RowLR>
			</>}
		</Column>
	);
});